export default "__VITE_ASSET__9b257f30__"